<script setup lang="ts">
import { SignUp } from '@/components';
</script>

<template>
    <div class="signup-container">
        <SignUp />
    </div>
</template>

<style scoped lang="scss">
.signup-container {
    height: 100vh;
    background-color: #f5f7fa;
}
</style>
